/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Accommodation in a room
 * @export
 * @interface TravelineBookingPlacementRqDto
 */
export interface TravelineBookingPlacementRqDto {
    /**
     * String representation of accommodation
     * @type {string}
     * @memberof TravelineBookingPlacementRqDto
     */
    code: string;
}

/**
 * Check if a given object implements the TravelineBookingPlacementRqDto interface.
 */
export function instanceOfTravelineBookingPlacementRqDto(value: object): value is TravelineBookingPlacementRqDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function TravelineBookingPlacementRqDtoFromJSON(json: any): TravelineBookingPlacementRqDto {
    return TravelineBookingPlacementRqDtoFromJSONTyped(json, false);
}

export function TravelineBookingPlacementRqDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingPlacementRqDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

  export function TravelineBookingPlacementRqDtoToJSON(json: any): TravelineBookingPlacementRqDto {
      return TravelineBookingPlacementRqDtoToJSONTyped(json, false);
  }

  export function TravelineBookingPlacementRqDtoToJSONTyped(value?: TravelineBookingPlacementRqDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

